import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteCourse as deleteCourseApi } from "@/services/dashboard/apiCourses";
import toast from "react-hot-toast";

function useDeleteCourse() {
    const queryClient = useQueryClient();

    const {
        mutate: deleteCourse,
        isLoading: isDeleting,
        error,
    } = useMutation({
        mutationFn: deleteCourseApi,
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["coursesDashboard"],
            });
            toast.success("تم حذف الكورس بنجاح");
        },

        onError: (error) => {
            toast.error(error.response.data.message);
        },
    });

    return { deleteCourse, isDeleting, error };
}
export default useDeleteCourse;
